module.exports = __webpack_public_path__ + "f92892fe6b6ea306e52ea479c6e536e0.png";